import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getFileName, getFilteredTrades, getSelectedTradeType, getOpenTradeId } from "./selectors"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators as CompositeCreators } from "modules/analyze-composite-security/model"
import { getPortfolioName } from "modules/portfolio-root/selectors/portfolios"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    fileName: getFileName(state, props),
    portfolioName: getPortfolioName(state),
    tradeType: getSelectedTradeType(state),
    trades: getFilteredTrades(state, props),
    openTradeId: getOpenTradeId(state),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
    openCompositeSecurity: CompositeCreators.openCompositeSecurity,
  },
})
